import React from 'react';
import { motion } from 'framer-motion';

const ClientLogosCarousel = () => {
  // Client logos from the logos folder
  const clientLogos = [
    { name: 'AfroSport', image: '/logos/afrosport.png' },
    { name: 'CMC', image: '/logos/cmc-logo_1.png' },
    { name: 'Flow Sports', image: '/logos/Flow_Sports_Logo_Stacked_RGB.png' },
    { name: 'NCF', image: '/logos/ncf logo.png' },
    { name: 'One Caribbean', image: '/logos/one caribbean.png' },
    { name: 'TV8', image: '/logos/tv8.jpg' }
  ];

  // Duplicate the logos array for seamless infinite scroll
  const duplicatedLogos = [...clientLogos, ...clientLogos];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary-800 mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-lg text-primary-600 max-w-2xl mx-auto">
            We're proud to work with these respected organizations across the Caribbean
          </p>
        </motion.div>

        {/* Continuous Scrolling Container */}
        <div className="relative overflow-hidden">
          <motion.div
            className="flex space-x-8 md:space-x-12"
            animate={{
              x: [0, -50 + '%']
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 40,
                ease: "linear",
              },
            }}
          >
            {duplicatedLogos.map((logo, index) => (
              <motion.div
                key={`${logo.name}-${index}`}
                className="flex-shrink-0 flex items-center justify-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <div className="bg-white rounded-lg p-4 md:p-6 shadow-md hover:shadow-lg transition-shadow duration-300 min-w-[120px] md:min-w-[150px] h-20 md:h-24 flex items-center justify-center">
                  <img
                    src={logo.image}
                    alt={logo.name}
                    className="max-h-12 md:max-h-16 w-auto object-contain"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogosCarousel;
